import React from 'react';
import { DateTime } from 'luxon';
import { capitalized } from 'vl-common/src/lib/capitilize';
import styled from '@emotion/styled';
import useUser from '@vl-core/hooks/useUser';
import { useTranslation } from 'react-i18next';

const StyledText = styled.p`
  margin-bottom: 0;
`;

export interface SuccessBookingMessageProps {
  apptDate?: Date | null;
  callType?: string | null;
  clinicianName?: string;
}

export const SuccessBookingMessage = ({
  apptDate,
  callType,
  clinicianName
}: SuccessBookingMessageProps): React.ReactNode => {
  const { t } = useTranslation('common');
  const user = useUser();

  if (!apptDate || !callType || !clinicianName) return null;

  return (
    <>
      <StyledText>
        {t('Appointment is booked with')} <strong>{clinicianName}</strong>
      </StyledText>

      <StyledText>
        {DateTime.fromJSDate(apptDate).setZone(user.timezone).toFormat("cccc, d LLLL yyyy 'at' HH:mm")}
      </StyledText>

      <StyledText>
        {t('Type:')}{' '}
        <strong>
          {capitalized(callType)} {t('Call')}
        </strong>
      </StyledText>
    </>
  );
};

export default SuccessBookingMessage;
